import { useMediaQuery } from "./use-media-query";

/**
 * Hook to detect device type based on screen width and orientation.
 * All values are undefined during SSR/hydration.
 *
 * Breakpoints:
 * - Mobile: < 640px (sm) OR landscape with limited height on touch devices
 * - Tablet: 640px - 1023px (excluding mobile landscape)
 * - Desktop: >= 1024px (lg)
 *
 * Mobile landscape detection:
 * - Landscape orientation (width > height)
 * - Limited viewport height (max-height: 500px)
 * - Touch device (pointer: coarse)
 */
export function useMobile() {
  const isMobilePortrait = useMediaQuery("(max-width: 639px)");
  const isMobileLandscape = useMediaQuery(
    "(orientation: landscape) and (max-height: 500px) and (pointer: coarse)"
  );
  const isMobile = isMobilePortrait || isMobileLandscape;

  const isTablet = useMediaQuery(
    "(min-width: 640px) and (max-width: 1023px) and (not ((orientation: landscape) and (max-height: 500px) and (pointer: coarse)))"
  );
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const isLoading = isMobilePortrait === undefined;

  return { isMobile, isTablet, isDesktop, isLoading };
}
